import Vue from "vue";
import Router from "vue-router";
import index from "@/page/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      redirect: "/home",
      children: [
        {
          path: "home",
          name: "index",
          meta: {
            active: "home",
          },
          component: () => import("@/page/home"),
        },
        {
          path: "product",
          name: "product",
          meta: {
            active: "product",
          },
          component: () => import("@/page/product"),
        },
        {
          path: "about",
          name: "about",
          meta: {
            active: "about",
          },
          component: () => import("@/page/about"),
        },
        {
          path: "news",
          name: "news",
          meta: {
            active: "news",
          },
          component: () => import("@/page/news"),
        },
        {
          path: "partner",
          name: "partner",
          meta: {
            active: "partner",
          },
          component: () => import("@/page/partner"),
        },
        {
          path: "contact",
          name: "contact",
          meta: {
            active: "contact",
          },
          component: () => import("@/page/contact"),
        },
      ],
    },
  ],
});

// 全局前置守卫:每次路由切换时，都会调用beforeEach
// to：要跳转到哪 from：当前导航要离开的路由信息 next是否继续跳转路由 如果要就调用next()
router.beforeEach((to, from, next) => {
  // 获取到前面打过标签的元素，将其scrollTop属性设置为0
  document.documentElement.scrollTop = 0;
  // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
  document.body.scrollTop = 0;
  // 调用继续路由跳转
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js